import React, { useRef, useState } from 'react'
import { DisplayMessage } from '../../Components'
import { connect } from 'react-redux'
import { ERROR, SUCCESS } from '../../utils/messageTypes'
import { OutlinedButton } from '../../elements'
import { Box } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { useStyles } from './styles'

function UploadFile(props) {
  const classes = useStyles()

  const { onValueChange, isCSV, uploadId } = props

  const [filename, setFileName] = useState(null)
  const [openToastMessage, setOpen] = useState(false)
  const [messageType, setMessageType] = useState('')
  const [message, setMessage] = useState('')

  const hiddenFileInput = useRef(null)

  const handleFileUploadClick = (id, event) => {
    hiddenFileInput.current.click()
  }

  return (
    <>
      <Box>
        {filename ? <CheckCircleIcon className={classes.checkCircleIcon}></CheckCircleIcon> : <></>}
        {filename ? <span className={classes.uploadText}>Uploaded</span> : <></>}
        <OutlinedButton label={filename ? 'RE-UPLOAD' : 'UPLOAD'} width='108px' height='30px' fontSize='12px' onClick={(event) => handleFileUploadClick(event)} />
        <input id={uploadId} type="file" ref={hiddenFileInput}
          onChange={(event) => {
            if (event.target.files[0]) {
              if (
                event.target.files[0].type === (isCSV ? 'text/csv' : 'application/pdf') &&
                event.target.files[0].size <= 10000000
              ) {
                setFileName(event.target.files[0].name)
                onValueChange(event.target.files[0])
                setOpen(true)
                setMessage('Please click on SAVE to upload file.')
                setMessageType(SUCCESS)
              } else {
                if (event.target.files[0].type !== (isCSV ? 'text/csv' : 'application/pdf')) {
                  setOpen(true)
                  setMessage('Please upload files of ' + `${isCSV ? 'CSV' : 'PDF'}` + ' type')
                  setMessageType(ERROR)
                }
                else {
                  setOpen(true)
                  setMessage('Please upload files of size less than 10 MB')
                  setMessageType(ERROR)
                }
              }
            }
          }}
          style={{ display: 'none' }}
        />
        <DisplayMessage open={openToastMessage} message={message} messageType={messageType} handleClose={() => setOpen(false)} style={{ flexBasis: '100%' }} />
      </Box>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin } = auth
  return { currentUser, isSuperAdmin }
}

export default connect(mapStateToProps, {})(UploadFile)



